import {useSelector} from 'react-redux';
import urls from 'urls';
import {OverlayContentWrapper} from '~/CreateFabricInvitation/routes/EventGifting/components/OverlayContentWrapper/OverlayContentWrapper';
import {selectType} from '~/common/fabric/reducers/details/selectors';
import {getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {selectTemplateName} from '~/common/fabric/reducers/fabricTemplate/selector';
import {useScript} from '~/common/hooks/useScript';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

interface DonationOverlayProps {
  closeOverlay: () => void;
  isOpen: boolean;
}

const SESAME_UUID = '8a18be44-1e17-447f-9e0d-dd289b90c619';
const SESAME_FEATURED_COPY =
  'Join Evite in supporting Sesame Workshop in helping kids everywhere grow smarter, stronger, and kinder.';

export const DonationOverlay = ({closeOverlay, isOpen}: DonationOverlayProps) => {
  const eventId = useSelector(getEventId);
  const eventType = useSelector(selectType);
  const templateName = useSelector(selectTemplateName);
  const isSesame = templateName.indexOf('sesamestreet-') === 0;

  const isScriptLoaded = useScript(urls.get('pledge_url', {pledgeDomain: window.pledge_url}), {
    id: 'pledgeSdkId',
  });

  if (!isScriptLoaded || !eventId) return null;

  return (
    <ResponsivePanel
      isOpen={isOpen}
      onClose={closeOverlay}
      showTitle={false}
      modalId="charity-donation"
      showCover
      renderMobileViewAs="bottom-sheet"
      hideHeaderDivider
    >
      <OverlayContentWrapper>
        <div
          className="plg-search"
          data-partner-key={window.pledge_key}
          data-event-type={eventType}
          data-featured-uuid={isSesame ? SESAME_UUID : undefined}
          data-featured-copy={isSesame ? SESAME_FEATURED_COPY : undefined}
          data-item-id={`${eventId}_Organization`}
          data-template="branding-2025"
        />
      </OverlayContentWrapper>
    </ResponsivePanel>
  );
};
